var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarActive = function SvgCalendarActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "#262525",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8C62F0",
    d: "M6.805 36a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 25c0 1.7 1.3 3 3 3h14c1.7 0 3-1.3 3-3v-8H8zm17-15h-2V9c0-.6-.4-1-1-1s-1 .4-1 1v1h-6V9c0-.6-.4-1-1-1s-1 .4-1 1v1h-2c-1.7 0-3 1.3-3 3v2h20v-2c0-1.7-1.3-3-3-3"
  })));
};
export default SvgCalendarActive;